<template>
  <v-autocomplete
    v-model="select"
    required
    solo
    :outlined="!$vuetify.breakpoint.xs"
    :flat="!$vuetify.breakpoint.xs"
    value="properties.longName"
    :items="items"
    item-text="properties.longName"
    :search-input.sync="search"
    hide-no-data
    return-object
    no-filter
    auto-select-first
    color="primary"
    :placeholder="`${$t('share.post.location')}`"
    persistent-hint
    :rules="rules"
    clearable
    :menu-props="{ maxWidth: `${this.autocompleteWidth}px` }"
    background-color="white"
    ref="autocomplete"
  >
    <template v-slot:append>
      <v-icon color="primary">fas fa-map-marker-alt</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
import ShareService from "../services/ShareService";

export default {
  name: "Autocomplete",

  props: {
    location: Object,
    index: Number
  },

  data() {
    return {
      items: [],
      search: null,
      select: ShareService.getFeature(),
      rules: [
        v =>
          (!!v && this.items.length > 0) ||
          this.$i18n.t("share.post.rules.location.required")
      ],
      autocompleteWidth: 0
    };
  },
  mounted() {
    if (this.location.properties.longName != "") {
      this.items.push(this.location);
      this.select = this.location;
      this.search = this.location.properties.longName;
    }
    this.autocompleteWidth = this.$refs.autocomplete.$el.clientWidth;
  },
  methods: {
    querySelections(search) {
      this.items = ShareService.updateSearchLocationAutocompleteItems(search);
    },
    updateDestinationAutocomplete() {
      let data = {
        index: this.index,
        location: this.select
      };
      if (this.select == undefined) {
        data.location = ShareService.getFeature();
      }
      this.$emit("updateDestinationAutocomplete", data);
    }
  },
  watch: {
    search(val) {
      if (val != "" && val != null) {
        if (this.select == undefined) {
          this.querySelections(val);
        } else if (val !== this.select.properties.longName) {
          this.querySelections(val);
        }
      }
    },
    select(v) {
      if (v != undefined) {
        if (
          this.select.properties.longName !== this.location.properties.longName
        ) {
          this.updateDestinationAutocomplete();
        }
      }
    }
  }
};
</script>

<style scoped></style>
